import { useCallback, useLayoutEffect, useRef, useState } from 'react';
import _ from 'lodash';

function getScrollPosition() {
  const el = document.getElementById('workspace-main');
  if (!el) return { toTop: 0, toBottom: 0 };

  const toTop = el.scrollTop;
  const toBottom = el.scrollHeight - el.clientHeight - toTop;

  return { toTop, toBottom };
}

export default function useScrollPosition() {
  const [position, setPosition] = useState(getScrollPosition());
  const lastPosition = useRef(position);
  const request = useRef();

  const updatePosition = useCallback(() => {
    const currentPosition = getScrollPosition();
    if (!_.isEqual(currentPosition, lastPosition.current)) {
      lastPosition.current = currentPosition;
      setPosition(currentPosition);
    }
  }, []);

  const handleRequest = useCallback(() => {
    updatePosition();
    request.current = window.requestAnimationFrame(handleRequest);
  }, [updatePosition]);

  useLayoutEffect(() => {
    request.current = window.requestAnimationFrame(handleRequest);
    return () => window.cancelAnimationFrame(request.current);
  }, [handleRequest]);

  return { position, updatePosition };
}
